import React from "react";
import Header from "../../Header";
import style from "./index.module.scss";
import classNames from "classnames";
import MHeader from "../../MHeader";
import useDeviceType from "Utils/useDeviceType";
import { useHistory } from "react-router-dom";

interface MainLayoutProps {
    children: React.ReactNode;
    className?: string;
    title: string;
}

export default function MainLayout({
    children,
    className,
    title
}: MainLayoutProps) {
    const history = useHistory();
    const { isPC } = useDeviceType();

    return (
        <div className={style.root}>
            {isPC && <Header />}
            {!isPC && <MHeader title={title} goBack={history.goBack} />}

            <div className={classNames(style.main, className)}>{children}</div>
        </div>
    );
}
